const TAGS_ENUMS = {
  TH: "th",
  TD: "td"
};
export {
  TAGS_ENUMS
};
//# sourceMappingURL=constants.mjs.map
